import { apiGet, buildApiURL } from '@src/services/api';

const getSessionTimeouts = () => {
    return apiGet(buildApiURL('/settings/session_timeouts'));
};

export {
    getSessionTimeouts,
};
